type MxpIframeStore = {
  navigateBack: (() => void) | undefined;
};

export const mxpIframeStore: MxpIframeStore = {
  navigateBack: undefined,
};
